import { Injectable } from '@angular/core';

@Injectable()
export class TimeService {
  constructor() { }

    public getTimezone() {
        let tzone = new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1];
        tzone = tzone.replace('\+', '%2B').replace('\-', '%2D');
        return tzone;
    }
}
